import {i18n} from "../../translate/i18n";
import React from "react";
import {editTag, setTag} from "../../services/Tags.service";
import {toast} from "react-toastify";

export function setLabel(label){
  switch (label) {
    case 'temas_materiais': return 'Temas materiais';
    case 'hashtag': return 'Hashtag';
    case 'dim_m_c_stakeholder': return 'Dimensão stakeholder';
    case 'codigo_gri': return 'Código GRI';
    case 'dimensao_gri': return 'Dimensão GRI';
    case 'ods': return 'ODS';
    case 'codigo_sasb': return 'Código SASB';
    case 'dimensao_sasb': return 'Dimensão SASB';
    case 'setor_sasb': return 'Setor SASB';
    case 'tcfd': return 'TCFD';
    case 'flag_compromissos': return 'Compromissos';
  }
}

export const Tags = [
  {
    value: 'temas_materiais',
    label: 'Temas materiais'
  },
  {
    value: 'hashtag',
    label: 'Hashtag'
  },
  {
    value: 'codigo_gri',
    label: 'Código GRI'
  },
  {
    value: 'dimensao_gri',
    label: 'Dimensão GRI'
  },
  {
    value: 'codigo_sasb',
    label: 'Código SASB'
  },
  {
    value: 'dimensao_sasb',
    label: 'Dimensão SASB'
  },
  {
    value: 'setor_sasb',
    label: 'Setor SASB'
  },
  {
    value: 'ods',
    label: 'ODS'
  },
  {
    value: 'dim_m_c_stakeholder',
    label: 'Dimensão stakeholder'
  },
  {
    value: 'tcfd',
    label: 'TCFD'
  },
  {
    value: 'flag_compromissos',
    label: 'Compromissos'
  }
]

export function Select({setSelected}) {
  return (
      <select className="form-select" onChange={(e) => setSelected(e.target.value)}>
        <option value="">{i18n.t('placeholder.filterTag')}</option>
        {Tags.map(tag =>
            <option key={tag.value} value={tag.value}>{tag.label}</option>
        )}
      </select>
  )
}
export function SelectLang({setLanguage, language}) {
  return (
      <select
          defaultValue={language}
          className="form-select"
          onChange={(e) => setLanguage(e.target.value)}
      >
        <option value="pt-BR">Português</option>
        <option value="en-US">Inglês</option>
      </select>
  )
}

export function createTagAction(values) {
  setTag(values)
      .then(() => {
        toast.success(i18n.t('success.createTag'))
        return true
      }).catch(() => toast.warning(i18n.t('warning.errorTag')))
}

export function editTagAction(id, values) {
  editTag(id, values)
      .then(() => {
        toast.success(i18n.t('success.editTag'))
      }).catch(() => toast.warning(i18n.t('warning.errorTag')))
}
